// apps/client/src/assets/builders/dropbox.ts — the shop's drop box: a wooden box on four short legs, a coral rounded lid, a dark slot
// and a small brass coin plate on the front (+z).
import * as THREE from 'three';
import { RoundedBoxGeometry } from 'three/addons/geometries/RoundedBoxGeometry.js';
import { toyMaterial } from '../../characters/doll';
import type { CodeBuilder } from '../service';

export const builder: CodeBuilder = {
  id: 'dropbox',
  build() {
    const g = new THREE.Group();
    const part = (geo: THREE.BufferGeometry, hex: string, x: number, y: number, z: number) => {
      const m = new THREE.Mesh(geo, toyMaterial(hex));
      m.position.set(x, y, z);
      m.castShadow = m.receiveShadow = true;
      g.add(m);
      return m;
    };
    const leg = new RoundedBoxGeometry(0.1, 0.16, 0.1, 2, 0.03);
    for (const x of [-0.32, 0.32]) for (const z of [-0.22, 0.22]) part(leg, '#5E4733', x, 0.08, z);
    part(new RoundedBoxGeometry(0.8, 0.9, 0.6, 3, 0.08), '#7A5A3E', 0, 0.6, 0);
    part(new RoundedBoxGeometry(0.9, 0.14, 0.7, 3, 0.06), '#EE7A5B', 0, 1.1, 0);
    part(new RoundedBoxGeometry(0.42, 0.05, 0.03, 2, 0.012), '#2E2219', 0, 0.9, 0.3);
    const plate = part(new THREE.CylinderGeometry(0.1, 0.1, 0.025, 20), '#F6C85F', 0, 0.58, 0.305);
    plate.rotation.x = Math.PI / 2;
    return g;
  },
};
